import React from "react";
import { Form, Formik } from "formik";
import {
  defaultFilter,
  ISearchProps,
  SuggestionStatusEnum,
  SuggestionTypeEnum,
} from "./type";
import { SearchAccordion } from "../../../common";
import {
  generateSearchFormItem,
  getTreeData,
  mapEnumToList,
} from "../../../../utils/helper";
import { useTranslation } from "react-i18next";

const Search = ({ filter, data, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "Suggestion.createdAt",
                },
                {
                  type: "text",
                  name: "playerID",
                  label: "Suggestion.playerID",
                },
                {
                  type: "multiSelect",
                  name: "type",
                  label: "Suggestion.type",
                  treeData: getTreeData(mapEnumToList(SuggestionTypeEnum)),
                },
                {
                  type: "text",
                  name: "suggestionID",
                  label: "Suggestion.suggestionID",
                },
                {
                  type: "multiSelect",
                  name: "status",
                  label: "Suggestion.status",
                  treeData: getTreeData(mapEnumToList(SuggestionStatusEnum)),
                },
              ],
              defaultFilter(),
              t,
              data,
              "Suggestion"
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
